import React from "react";
import { connect, ConnectedProps } from "react-redux";

import { ReactComponent as Loader } from "../../../assets/icon/hun-com-loading-img.svg";
import Modal from "../Modal/Modal";

type Props = ConnectedProps<typeof connector>;

const LoaderModal: React.FC<Props> = ({ loading }) => {
  if (!loading) return null;

  return (
    <Modal>
      <Loader className="loader" />
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  loading: state.mrg.loading,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(LoaderModal);
